import Text from "../../../../styleguide/Text";
import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import usePermissions from "../../../../router/usePermissions";
import userRoles from "../../../../constants/userRoles";

function TableCustomHeader() {
  const { isAuthorized } = usePermissions();
  const CAR_CREATE_PERMISSION = isAuthorized(userRoles.CAR_CREATE);

  return (
    <div className="mb-5 flex items-center justify-between gap-4">
      <Text
        variant="h3"
        component="h3"
        className="!mb-0 font-semibold text-slate-900"
        gutterBottom>
        Flota
      </Text>
      <ActionMenu
        items={[
          {
            id: "add-car",
            label: "Adauga masina noua",
            icon: "ADD",
            tooltip:
              "Deschide formularul de adaugare a unui autovehicul in flota.",
            hidden: !CAR_CREATE_PERMISSION,
            navigate: "create",
          },
        ]}
        minItemsForMenu={2}
        ariaLabel="Actiuni pentru flota"
      />
    </div>
  );
}

export default TableCustomHeader;
